import type { RoomsState } from '../../types/mfc'
import { setScreenOrientation } from '../app-state/state.screen'
import { RoomEvent } from '../constants/enums'
import { pubSubRoom } from './pubSub'

type RoomIntervals = {
    [container: string]: IntervalContainer
}

type IntervalContainer = {
    interval: ReturnType<typeof setInterval>
}

export const roomIntervals: RoomIntervals = {
    autoPlay: { interval: undefined },
    pinnedRoomSession: { interval: undefined },
}

export const ROOMSTATE: RoomsState = {
    pinnedRooms: [],
    pinHelperID: null,
    restored: null,
}

if (typeof window !== 'undefined') {
    window.__MFC_APP_ROOM__ = ROOMSTATE
}

export const setPinnedRooms = (rooms: Array<number>) => {
    ROOMSTATE.pinnedRooms = rooms
    setScreenOrientation({ overrideSkip: true })
    pubSubRoom.emit(RoomEvent.PIN_ROOM, rooms, true)
}
export const setPinHelperID = (id?: number) => {
    ROOMSTATE.pinHelperID = id
    pubSubRoom.emit(RoomEvent.PIN_HELPER_ID, id, !!id)
}

export const setRoomsRestored = (restored) => {
    ROOMSTATE.restored = restored
    pubSubRoom.emit(RoomEvent.RESTORED, restored)
}
